<template>
  <div class="page__container">
    <div class="page__title">
      Пожалуйста, ожидайте...
    </div>
    <div class="page__subtitle">
      Происходит проверка, скоро вы будете перенаправлены на страницу входа.
    </div>
    <div>
      <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
        <fulfilling-square-spinner
            :animation-duration="4000"
            :size="100"
            color="#3254B9"
        />
      </v-row>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import { FulfillingSquareSpinner } from "epic-spinners"
import pa_names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters } from "vuex"

export default defineComponent({
  name: "RegistrationInfoApproveEmail",
  components: { FulfillingSquareSpinner },
  computed: {
    pa_names () {
      return pa_names
    },
    names () {
      return names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    })
  },
  methods: {
    ...mapActions({
      approveEmail: 'personal_account/users/approveEmail',
    }),
    endRedirect () {
      this.$router.push({ name: names.MAIN })
    },
    sendApprove (token) {
      this.approveEmail(
        {
          data: { token: token },
          finalizer: () => {
            this.endRedirect()
          },
          catcher: () => {
            this.endRedirect()
          }
        }
      )
    },
  },
  created () {
    if (this.$route.query.token) {
      this.sendApprove(this.$route.query.token)
    } else {
      this.endRedirect()
    }
  },
})
</script>

<style scoped lang="scss">
.page__container {
  width: 100%;
  max-width: 1280px;
  margin: 150px auto;
}

.page__title {
  margin-top: 30px;
  margin-bottom: 30px;
  font-style: normal;
  font-weight: 800;
  font-size: 75px;
  line-height: 84px;
  text-align: center;

  color: #3254B9;
}

.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 51px;
  text-align: center;

  color: #313743;
}

@media screen and (max-width: 1920px) {
  .page__title {
    font-size: 65px;
    line-height: 74px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 41px;
  }
}

@media screen and (max-width: 1279px) {
  .page__title {
    font-size: 50px;
    line-height: 57px;
    padding: 0 40px;
  }

  .page__subtitle {
    font-size: 24px;
    line-height: 31px;
    padding: 0 40px;
  }
}

@media screen and (max-width: 768px) {
  .page__title {
    font-size: 30px;
    line-height: 37px;
    padding: 0 20px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }
}
</style>
